<template>
  <div>
    <BaseTitle style="margin-bottom: 5px;" pageTitle="COMUNICADOS" />
    <v-dialog v-model="isActiveCommunication" width="800" hide-overlay>
      <v-card>
        <Communication
          :key="communicationkey"
          :communication="communication"
          :hasClose="true"
          @close="close($event)"
        />
      </v-card>
    </v-dialog>
    <v-card outlined>
      <v-card-title>
        <v-row>
          <v-col cols="11">
            <v-text-field
              v-model="search"
              outlined
              hide-details
              label="Pesquisar"
              placeholder="Pesquise por Comunicado ou Data de expiração(DD/MM/AAAA)"
              append-icon="mdi-magnify"
              @click:append="searchCommunications(1)"
              @change="searchCommunications(1)"
            ></v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-tooltip color="blue" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="blue" v-on="on" v-bind="attrs"
                  >icon-danger mdi-rotate-180</v-icon
                >
              </template>
              <p class="ma-0 pa-0">
                Para pesquisar por data de expiração utilize o formato
                "DD/MM/AAAA"
              </p>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col>
            <BaseDataTable
              disable-sort
              keyItem="cd_comunicado"
              pagination
              :headers="headers"
              :items="items"
              :length="communications.last_page"
              :total="communications.total"
              :page="page"
              :selectable="false"
              :loading="loading"
              :item-class="setRowClass"
              @paginate="searchCommunications"
              @onView="viewItem"
            >
              <template v-slot:[`item.ds_comunicado`]="{ item }">
                <span>{{ truncateString(item.ds_comunicado) }}</span>
              </template>
            </BaseDataTable>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import _ from "lodash";
import store from "./_store";
import BaseTitle from "../../components/UI/BaseTitle.vue";
import BaseDataTable from "../../components/UI/BaseDataTable.vue";
import { mapActions, mapGetters } from "vuex";
import Communication from "./_components/view.vue";

export default {
  components: {
    BaseTitle,
    BaseDataTable,
    Communication
  },
  data() {
    return {
      search: "",
      loading: false,
      page: 1,
      isActiveCommunication: false,
      communication: {},
      communicationkey: 0,
      headers: [
        {
          value: "actions",
          actions: [
            {
              type: "button",
              click: "onView",
              icon: "icon-eye",
              options: { fab: true, icon: true, small: true }
            }
          ]
        },
        { text: "Comunicado", value: "ds_comunicado" },
        { text: "Data de Expiração", value: "dt_expiracao", format: "date" }
      ],
      items: []
    };
  },

  beforeCreate() {
    const STORE_COMMUNICATION = "$_communication";
    if (!(STORE_COMMUNICATION in this.$store._modules.root._children))
      this.$store.registerModule(STORE_COMMUNICATION, store);
  },

  async created() {
    await this.searchCommunications();
  },

  computed: {
    ...mapGetters({
      communications: "$_communication/communications"
    })
  },

  methods: {
    ...mapActions({
      getCommunications: "$_communication/getCommunications",
      getCommunicationsNotification:
        "$_communication/getCommunicationsNotification"
    }),

    async searchCommunications(page = 1) {
      this.page = page;
      this.loading = true;
      await this.getCommunications({
        page: this.page,
        search: this.search
      });
      this.items = this.communications.data;
      this.loading = false;
    },

    async viewItem(item) {
      this.communicationkey++;
      this.communication = Object.assign({}, item);
      this.isActiveCommunication = true;
      item.view = true;
      await this.getCommunicationsNotification({
        limit: -1
      });
    },

    setRowClass(item) {
      if (item.view) return "visualized";
      else return "not-viewed";
    },

    async close(event) {
      this.isActiveCommunication = event;
    },

    truncateString(string) {
      if (string)
        return _.truncate(string, {
          length: 100,
          omission: "..."
        });
      return "";
    }
  }
};
</script>
<style lang="scss">
.not-viewed {
  background-color: #f6f4f4;
  font-weight: bold;
}
.visualized {
  background-color: #f6f4f4;
}
</style>
